
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M14.851 15.144l.533 2.374c0 .307.974 2.6.722 2.732-.252.132-2.515-1.681-2.731-1.875l-3.776-3.244-2.705.013C5.296 15.144 4 13.718 4 11.96V7.184C4 5.425 5.296 4 6.894 4h9.212C17.704 4 19 5.425 19 7.184v4.776c0 1.758-1.296 3.184-2.894 3.184h-1.255z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    